<template>
  <section id="category-pc-movement">
    <figure class="chart">
      <div class="row clearfix">
        <h1>Percentage Movement by Category</h1>
        <highcharts v-if="percentageMovement" id="category-pc-movement-graph" class="graphcontainer" :options="percentageMovement"></highcharts>
      </div>

    </figure>

    <figure id="category-pc-movement-table" class="data">
      <div class="row clearfix">
        <a href="#" data-table="category-pc-movement-table" class="closetable" title="Close Table">Close Table</a>
      </div>
    </figure>

    <div class="fullbg">
      <p class="caption">Photo: <em>Yours Truly</em> performing at Good Things Festival 2025, Photo Credit: Kane Hibberd</p>
    </div>
  </section>
</template>

<script>
/*eslint-disable */
export default {
  data () {
    return {
      activeYear: '2024 - 2025',
      years: [
        '2017 - 2018',
        '2018 - 2019',
        '2019 - 2020',
        '2020 - 2021',
        '2021 - 2022',
        '2022 - 2023',
        '2023 - 2024',
        '2024 - 2025',
      ],
      reports: [
        {
          year: '2024 - 2025',
          revenue: [{y: -4.7}, {y: -8.4}, {y: 159.6}, {y: 28.6}, {y: -24.0}, {y: -0.9}, {y: 10.1}, {y: 20.7}, {y: -16.8}, {y: 48.0}, {y: -30.1}, {y: -3.8}],
          attendance: [{y: -3.4}, {y: -5.4}, {y: 88.1}, {y: 6.7}, {y: -10.2}, {y: -2.4}, {y: 10.1}, {y: 4.9}, {y: -16.6}, {y: 33.2}, {y: -10.4}, {y: -9.1}],
        },
        {
          year: '2023 - 2024',
          revenue: [{y: 3.8}, {y: 13.8}, {y: -63.5}, {y: 14.5}, {y: -14.0}, {y: 21.8}, {y: -9.0}, {y: -6.7}, {y: -2.0}, {y: -22.2}, {y: 215.5}, {y: -13.4}],
          attendance: [{y: -10.4}, {y: 10.9}, {y: -44.6}, {y: 7.6}, {y: -15.4}, {y: 17.3}, {y: -7.5}, {y: -0.9}, {y: 2.1}, {y: -16.8}, {y: 34.6}, {y: -3.6}],
        },
        {
          year: '2022 - 2023',
          revenue: [{y: 11.1}, {y: 41.1}, {y: 200.6}, {y: 1.6}, {y: 72.9}, {y: 110.6}, {y: 31.8}, {y: 51.5}, {y: 4.5}, {y: 68.8}, {y: -34.8}, {y: 9.3}],
          attendance: [{y: 9.1}, {y: 14.9}, {y: 113.9}, {y: 10.0}, {y: 35.0}, {y: 38.0}, {y: 13.5}, {y: 32.1}, {y: 0.4}, {y: 42.6}, {y: 36.2}, {y: 5.4}],
        },
        {
          year: '2021 - 2022',
          revenue: [
            {y: 135.1},
            {y: 40.1},
            {y: 7.1},
            {y: 134.2},
            {y: 128.6},
            {y: 387.1},
            {y: 86.1},
            {y: 357.1},
            {y: 156.5},
            {y: 51.2},
            {y: 86.3},
            {y: 107.9}
          ],
          attendance: [
            {y: 103.7},
            {y: 41.6},
            {y: 19.8},
            {y: 97.5},
            {y: 82.0},
            {y: 218.5},
            {y: 36.7},
            {y: 232.8},
            {y: 139.2},
            {y: 49.0},
            {y: 81.6},
            {y: 106.1}
          ],
        },
        {
          year: '2020 - 2021',
          revenue: [
            {y: 257.6},
            {y: 229.9},
            {y: -6.5},
            {y: 109.7},
            {y: 134.1},
            {y: -53.1},
            {y: -4.6},
            {y: -5.3},
            {y: 201.8},
            {y: 38.3},
            {y: -44},
            {y: 34.4}
          ],
          attendance: [
            {y: 164.6},
            {y: 177.9},
            {y: -0.9},
            {y: 105.4},
            {y: 246.2},
            {y: -4.9},
            {y: -0.9},
            {y: 5.6},
            {y: 144.8},
            {y: 2.2},
            {y: -52.8},
            {y: 56.8}
          ],
        },
        {
          year: '2019 - 2020',
          revenue: [
            {y: -88.6},
            {y: -76.2},
            {y: -79.3},
            {y: -28.2},
            {y: -70.0},
            {y: -80.1},
            {y: -63.0},
            {y: -71.9},
            {y: -78.2},
            {y: -72.8},
            {y: -52.2},
            {y: -79.2}
          ],
          attendance: [
            {y: -82.9},
            {y: -67.7},
            {y: -78.0},
            {y: -27.9},
            {y: -69.8},
            {y: -78.9},
            {y: -65.4},
            {y: -66.0},
            {y: -61.3},
            {y: -72.4},
            {y: -57.0},
            {y: -84.4}
          ],
        },
        {
          year: '2018 - 2019',
          revenue: [
            {y: 3.4},
            {y: -27.0},
            {y: 9.9},
            {y: -20.3},
            {y: 77.3},
            {y: -15.7},
            {y: -15.9},
            {y: -14.4},
            {y: -3.5},
            {y: 86.7},
            {y: 102.7},
            {y: -17.3}
          ],
          attendance: [
            {y: 0.3},
            {y: -29.0},
            {y: 4.3},
            {y: -15.7},
            {y: 48.5},
            {y: -11.9},
            {y: -13.7},
            {y: -10.6},
            {y: 152.9},
            {y: 7.0},
            {y: 41.9},
            {y: -11.6}
          ],
        },
        {
          year: '2017 - 2018',
          revenue: [
            {y: 2.6},
            {y: 16.5},
            {y: 2.0},
            {y: 26.2},
            {y: 1.3},
            {y: -4.0},
            {y: 32.2},
            {y: 29.2},
            {y: 337.9},
            {y: 22.2},
            {y: -79.9},
            {y: 72.5}
          ],
          attendance: [
            {y: -1.2},
            {y: 26.4},
            {y: -4.3},
            {y: 38.1},
            {y: 14.4},
            {y: -3.1},
            {y: 19.2},
            {y: 31.9},
            {y: 24.5},
            {y: -1.9},
            {y: -61.3},
            {y: 98.5}
          ],
        }
      ]
    }
  },
  computed: {
    percentageMovement () {
      const self = this

      for (let i = 0; i < self.reports.length; i++) {
        const report = self.reports[i]
        if (report.year === self.activeYear) {
          return {
            chart: {
              type: 'bar',
              backgroundColor: 'transparent'
            },
            title: {
              text: ''
            },
            yAxis: {
              title: {
                text: 'Percentage Change',
                style: {
                  color: '#fff'
                }
              },
              valueSuffix: '%',
              labels: {
                style: {
                  color: '#fff'
                }
              }
            },
            xAxis: {
              title: {
                text: ''
              },
              categories: [
                'Ballet and Dance',
                'Children\'s/Family',
                'Circus and Physical Theatre',
                'Classical Music',
                'Comedy',
                'Contemporary Music',
                'Festivals (Multi-Category)',
                'Festivals (Contemporary Music)',
                'Musical Theatre',
                'Opera',
                'Special Events',
                'Theatre'
              ],
              labels: {
                style: {
                  color: '#fff'
                }
              }
            },
            series: [
              {
                name: 'Change in Attendance',
                data: report.attendance,
                color: '#d14967'
              },
              {
                name: 'Change in Revenue',
                data: report.revenue,
                color: '#3a89eb'
              }
            ],
            legend: {
              layout: 'vertical',
              align: 'center',
              verticalAlign: 'bottom',
              floating: false,
              backgroundColor: '#FFFFFF'
            },
            tooltip: {
              shared: true,
              valueSuffix: '%',
              followPointer: true,
              valueDecimals: 1
            }
          }
        }
      }

      return false
    }
  },
}
</script>

<style lang="scss" scoped>
#category-pc-movement .fullbg {
  background-image: url("~@/assets/img/2025/17 Percentage Movement DAL - YOURS TRULY AT GTF - KANE HIBBERD (1).jpg");
}
</style>
